import React from 'react'
import { Link } from 'react-router-dom'
// Components
import LinksMap from '../components/LinksMap'
import PageTransition from '../components/PageTransition'
// CSS
import '../assets/css/wishlist.css'

export default function Wishlist() {
  return (
    <div className='wishlist_page'>
      <PageTransition />
      <LinksMap linksArr={[{name: 'Home', path: '/', active: false}, {name: 'Wishlist', path: '/wishlist', active: true}]} pageName='Wishlist' />
      <div className='container'>
        <div className='wishlist'>
          <div className='card'>
            <div className='thumbnail'>
              <img src='https://via.placeholder.com/150' alt='product' />
              <button className='remove_btn fas fa-times'></button>
            </div>
            <div className='details'>
              <div className='title'>Black Grey Headset</div>
              <div className='price'>$200</div>
              <div className='stock'>In Stock</div>
            </div>
            <div className='actions'>
              <Link to='/product'>SELECT OPTIONS</Link>
            </div>
          </div>
          
          <div className='card'>
            <div className='thumbnail'>
              <img src='https://via.placeholder.com/150' alt='product' />
              <button className='remove_btn fas fa-times'></button>
            </div>
            <div className='details'>
              <div className='title'>Black Grey Headset</div>
              <div className='price'>$200</div>
              <div className='stock'>In Stock</div>
            </div>
            <div className='actions'>
              <Link to='/product'>SELECT OPTIONS</Link>
            </div>
          </div>
        </div>

        <div className='wishlist_empty'>
          <span className='far fa-heart'></span>
          <p>No products added to the wishlist</p>
          <Link to='/products'>GO SHOP</Link>
        </div>
      </div>
    </div> 
  )
}
